<div class="labelContainer">
  <label class="label">{{ translationCode | translate }}</label>
  <div class="optional" *ngIf="optional">{{ 'SHARED.LABELS.OPTIONAL' | translate }}</div>
</div>
